import { useQuery } from '@tanstack/react-query';

import { fetchMyEmployeeRecord } from '../api/fetch-my-employee-record.js';
import { meKeys } from './keys.js';

export function myEmployeeRecordQueryDefinition() {
  return {
    queryKey: meKeys.employeeRecord(),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchMyEmployeeRecord(signal),
    staleTime: Infinity,
    meta: {
      toast: {
        title: 'Could not load employee record',
        description: 'Your employee record could not be fetched.',
      },
    },
  } as const;
}

export function useMyEmployeeRecordQuery(enabled = true) {
  return useQuery({
    ...myEmployeeRecordQueryDefinition(),
    enabled,
  });
}
